import { type ConnectionStatus, isTier, tierBars } from '@/components/network-status/networkTier'
import { cn } from '@/lib/utils'
import { WifiOff } from 'lucide-react'

const BARS = [
	{ y: 11, height: 4 },
	{ y: 8, height: 7 },
	{ y: 5, height: 10 },
	{ y: 2, height: 13 },
]

/** Phone style signal bars; unlit bars stay faint so the count reads at a glance. */
export const SignalBars = ({ lit, className }: { lit: number; className?: string }) => (
	<svg viewBox='0 0 16 16' className={cn('size-(--icon-standalone) shrink-0', className)} aria-hidden='true'>
		{BARS.map((bar, i) => (
			<rect
				key={bar.y}
				x={1 + i * 4}
				y={bar.y}
				width={2.5}
				height={bar.height}
				rx={0.75}
				fill='currentColor'
				opacity={i < lit ? 1 : 0.25}
			/>
		))}
	</svg>
)

export const StatusIcon = ({ status, className }: { status: ConnectionStatus; className?: string }) =>
	status === 'offline' ? (
		<WifiOff className={cn('size-(--icon-standalone) shrink-0', className)} aria-hidden />
	) : (
		<SignalBars lit={isTier(status) ? tierBars(status) : 0} className={className} />
	)
